<router-outlet></router-outlet>

@if (isAuthLoading) {
<div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]">
    <div class="bg-white p-5 rounded-lg text-center">
        <div class="w-10 h-10 border-4 border-gray-200 border-t-blue-600 rounded-full animate-spin mx-auto mb-2"></div>
        <div>Chargement en cours...</div>
    </div>
</div>
}